const key = "add-image-upload-field";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[1-9]*$/);
};

const imageField = {
	Id: -2,
	Name: "Image field",
	Key: {
		Code: "FILE.IMAGE"
	},
	Section: {
		Id: 219,
		IsSection: true,
		ParentContextRootSectionId: 0,
		Name: "",
		Order: 0
	},
	Type: {
		Code: "FILE",
		IsReferentialData: false,
		IsEntity: false
	},
	Description: "Description for image field",
	Order: 81,
	Template: "ImageUpload",
	MaxSize: 5242880,
	AllowedMimeTypes: "image/png;image/jpeg;image/gif;image/webp"
};

const modify = (resp) => {
	const form = resp.data.Data;
	const firstSection = form.Sections[0];

	const newImageField = {
		...imageField,
		Section: {
			...imageField.Section,
			Id: firstSection.Id
		}
	};

	form.Fields.push(newImageField);
};

export const addImageUploadField = [key, applicable, modify];
